import client from './client';
import { PipelineComparisonResponse } from '../types/companyPipeline';

export const getCompanyPipelineComparison = async (
  companyId: string,
  pipelineUrl?: string,
): Promise<PipelineComparisonResponse> => {
  const response = await client.get(
    `/api/v1/company-pipelines/${encodeURIComponent(companyId)}/comparison`,
    { params: pipelineUrl ? { pipeline_url: pipelineUrl } : undefined },
  );
  return response.data;
};
